import { render, staticRenderFns } from "./TinyInfoTotalRevenue.vue?vue&type=template&id=0aadd171"
import script from "./TinyInfoTotalRevenue.vue?vue&type=script&lang=ts"
export * from "./TinyInfoTotalRevenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aadd171')) {
      api.createRecord('0aadd171', component.options)
    } else {
      api.reload('0aadd171', component.options)
    }
    module.hot.accept("./TinyInfoTotalRevenue.vue?vue&type=template&id=0aadd171", function () {
      api.rerender('0aadd171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfoTotalRevenue.vue"
export default component.exports